import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares '
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Label } from 'semantic-ui-react'
import { EventInfoContext } from '../../../cnr/contexts/EventInfoContext'
import { filterHelpers } from '../../../common/filtering'
import { gEnums } from '../../../enums/globalEnums'
import { FormItemContext } from '../FormItem'
import Checker from './Checker'

const _allowedSortProps = [
  'appUserProfileSettings',
  'appUserPersonalPages',
  'navigationItems',
  'sideMenuItems'
]

const MenuItemsSelect = (props) => {

  const { menuList } = props

  const { formItem_state } = useContext(FormItemContext) ?? {}
  const { fip, itemProp } = formItem_state ?? {}

  const _fip = props.fip || fip || {}
  const _itemProp = props.itemProp || itemProp || {}

  const { onChange, propname, value: fip_value } = _fip
  const { data } = _itemProp ?? {}
  const { formItemType, staticView } = data ?? {}

  const allowSort = _allowedSortProps.includes(propname)

  const { eventInfo_state } = useContext(EventInfoContext) ?? {}
  const { staticViews } = eventInfo_state ?? {}

  const prevValueRef = useRef()

  const selectedStaticView = useMemo(() => {
    return staticViews && staticView ? staticViews?.[staticView] : null
  }, [staticViews, staticView])

  /**
   * Normalize menu list with selections
   */
  const normalizedMenuList = useMemo(() => {

    if (!menuList) return []

    const list = _.cloneDeep(menuList)

    if (_.isArray(fip_value)) {
      fip_value.forEach((fipv, index) => {

        const val = _.isObject(fipv) ? fipv.value : fipv
        const item = _.find(list, { value: val })

        if (item) {
          item.selected = true
          item.position = index
        }

      })
    }

    return _.sortBy(list, ['position', 'text'])

  }, [menuList, fip_value])

  const [selectedList, setSelectedList] = useState(normalizedMenuList)
  const [toggleSelectOn, setToggleSelectOn] = useState(false)

  useEffect(() => {
    setSelectedList(normalizedMenuList)
  }, [normalizedMenuList])


  const valueCount = fip_value ? Object.keys(fip_value).length : 0

  /**
   * Selection helpers
   */

  const getSelectedKeys = (list) =>
    _.chain(list)
      .filter({ selected: true })
      .map('value')
      .value()

  const updatePropValue = (sis) => {

    const data = { propname }

    if (selectedStaticView) {

      const sisf = {}

      if (_.isArray(sis)) {

        sis.forEach(si => {
          const x = filterHelpers.find(selectedStaticView, 'key', si)
          if (x) sisf[si] = x
        })

      }

      handleChange(data, sisf)

    } else {

      handleChange(data, sis)

    }

  }

  const handleChange = (data, sisf) => {
    onChange(null, data, null, sisf)
  }

  useEffect(() => {

    if (!selectedList) return

    let nextValue

    if (formItemType === gEnums.formItemTypes.menuItemSelectFull) {
      nextValue = _.filter(selectedList, i => i.selected)
    } else {
      nextValue = getSelectedKeys(selectedList)
    }

    if (_.isEqual(prevValueRef.current, nextValue)) return

    prevValueRef.current = nextValue

    updatePropValue(nextValue)

  }, [selectedList])


  const handleSelect = (item) => {
    const next = selectedList.map(i =>
      i.value === item.value
        ? { ...i, selected: !i.selected }
        : i
    )
    setSelectedList(next)
  }

  const handleSelectAll = () => {

    const toggleOn = !toggleSelectOn

    const next = selectedList.map(i => ({
      ...i,
      selected: toggleOn
    }))

    setSelectedList(next)
    setToggleSelectOn(toggleOn)

  }

  const handleCount = (item, count) => {

    const next = selectedList.map(i =>
      i.key === item.key
        ? { ...i, count }
        : i
    )

    setSelectedList(next)

  }

  const hs = (items) => setSelectedList(items)

  const ims = (
    <ItemMenuSquares
      menuItems={selectedList}
      imsType={allowSort ? _imsTypes.sortSelect : _imsTypes.inline}
      onSort={hs}
      handleSelect={handleSelect}
    />
  )

  const header = (
    <div className='menu-select-header'>
      <div>
        {_.startCase(propname)}
        <Label color='blue'>{valueCount}</Label>
      </div>
      <div>
        <Checker
          item={{ key: 'checkAll' }}
          handleClick={handleSelectAll}
          checked={toggleSelectOn}
          label='Select All'
          size='small'
        />
      </div>
    </div>
  )

  return (
    <Wrapper
      header={header}
      content={selectedList && (ims)}
      wrapperType={wrapperTypes.padded}
    // noMid={true}
    />
  )

}

export default MenuItemsSelect